/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zippy_Lime_Anaconda_HugInputs */

const fr_zippy_lime_anaconda_hug = /** @type {(inputs: Zippy_Lime_Anaconda_HugInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier la catégorie`)
};

/**

* @param {Zippy_Lime_Anaconda_HugInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const zippy_lime_anaconda_hug = /** @type {((inputs?: Zippy_Lime_Anaconda_HugInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zippy_Lime_Anaconda_HugInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_zippy_lime_anaconda_hug(inputs)
});